export default {
  strength: "Force du mot de passe",
  "very-weak": "Très faible",
  weak: "Faible",
  good: "Bon",
  strong: "Fort",
}
